import 'css-chunk:src/app/containers/MemberDetail/components/MemberDetails/components/Social/SocialRow.scss';export default {
  "socialRow": "_socialRow_1pzfk_1",
  "socialValue": "_socialValue_1pzfk_17",
  "link": "_link_1pzfk_22",
  "btn": "_btn_1pzfk_28"
};